import { inject, Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Store } from '@ngrx/store';
import { AccessActions } from 'src/app/core/store/access/access.actions';
import { GuardianActions } from 'src/app/core/store/guardian/guardian.actions';
import { ImageCacheActions } from 'src/app/core/store/image-cache/image-cache.actions';
import { ResourceActions } from 'src/app/core/store/resources/resource.actions';
import { PushNofiticationsService } from '../../communication/push-nofitications.service';
import { FeatureFlagService } from '../../feature-flags/feature-flag.service';
import { LookupService } from '../../lookup/lookup.service';

@Injectable({
  providedIn: 'root',
})
export class BootstrapService {
  private readonly store = inject(Store);
  private readonly lookupService = inject(LookupService);
  private readonly pushNofiticationsService = inject(PushNofiticationsService);
  private readonly featureFlagService = inject(FeatureFlagService);

  dispatchPostLoginActions(): void {
    // Clear image cache to ensure fresh images
    this.store.dispatch(ImageCacheActions.clearAllImageCache());
    if (Capacitor.isNativePlatform()) {
      this.pushNofiticationsService.initDeviceRegistration();
    } else {
      console.log('Not initializing push notifications - not a native platform');
    }
    this.store.dispatch(AccessActions.loadUserAccess());
    this.store.dispatch(GuardianActions.loadLoggedinGuardian());
    this.store.dispatch(ResourceActions.loadNewsArticles());
    this.getAllLookupData();
    this.featureFlagService.load().subscribe();
  }

  getAllLookupData() {
    this.lookupService.getPhoneNumberTypes();
    this.lookupService.getEmailTypes();
    this.lookupService.getRelationships();
    this.lookupService.getCountriesWithDialCodes();
    this.lookupService.getMedicalAidProviders();
    this.lookupService.getMartialStatusList();
    this.lookupService.getTitleList();
    this.lookupService.getParentalStatusList();
    this.lookupService.getRelationshipList();
  }
}
